module.exports = __webpack_public_path__ + "images/index/img04-4.a58a8ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/kua/img04-4.jpg
// module id = cx8v
// module chunks = 21